import { useContext } from 'react';

import { Field, Link, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ModalContext } from 'src/context/Modal/ModalContext';

import { useLoginReturnUrl } from 'src/hooks/useLoginReturnUrls';

import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';

import { Button } from 'src/components/basicContent/_Button/Button';

import styles from './_LoggedOutButtons.module.css';

type LoggedOutButtonsProps = {
	fields: {
		LogInLink?: LinkField;
		SignUpLink?: LinkField;
		LogOutText?: Field<string>;
	};
	authenticatedUserProfile?: AuthenticatedUserProfile;
};

export default function LoggedOutButtons(props: LoggedOutButtonsProps): JSX.Element {
	const ModalState = useContext(ModalContext);
	const { getLoginUrlWithReturnDestination } = useLoginReturnUrl();

	const loginUrl = getLoginUrlWithReturnDestination(props.fields?.LogInLink);

	return !props.authenticatedUserProfile ? (
		<div className={styles.loggedOutBtns}>
			{props.fields?.SignUpLink && <Link field={props.fields?.SignUpLink} className={`${styles.signUpBtn} button`} />}

			{loginUrl && (
				<Button
					title={props.fields?.LogInLink?.value?.text ?? 'Log in'}
					className={`button pinkDark ${styles.button}`}
					onClick={() =>
						ModalState.updateDisplayLoginFormModal(
							ModalState.modalInfo?.LoginFormModal !== undefined ? !ModalState.modalInfo.LoginFormModal.Display : true
						)
					}
				>
					{props.fields?.LogInLink?.value?.text ?? 'Log in'}
				</Button>
			)}
		</div>
	) : (
		<></>
	);
}
